import React, { Component } from 'react';
import { Menu, Dropdown, Upload, Button } from 'antd';
import intl from 'react-intl-universal';
import './OpenFile4K.scss';
import '../common4K.scss';
import { isCNDomain } from 'Utils/utils';
import { store } from 'Store/store.index';
import {observer} from "mobx-react";
import { LANG_CHANGE } from 'Store/constants';
import { iManage } from '@/api/drives.constants';

const { Dragger } = Upload;
@observer
class OpenFile extends Component {
  constructor(props) {
    super(props);
    this.StartPDFHere = null;
    this.StartPDFHereDescribe = null;
    this.DragDrop = null;
    this.DragButton = null;
    this.DragButton2 = null;
    this.ChooseFile = null;
    store.netDriverStore.setReloadFirstPageMenu(this.menuList);
    store.appStore.addAppEventListener(LANG_CHANGE, this.forceUpdate.bind(this));
  }
  componentWillUnmount () {
    this.setState = () => { return }
    store.appStore.removeAppEventListener(LANG_CHANGE);
  }
  initIntlLang = () => {
    this.StartPDFHere = intl.formatMessage({ id: 'GetStartGuid.StartPDFHere' });
    this.StartPDFHereDescribe = intl.formatMessage({ id: 'GetStartGuid.StartPDFHereDescribe' });
    this.DragDrop = intl.getHTML('GetStartGuid.DragDrop');
    this.DragButton = intl.getHTML('GetStartGuid.DragButton');
    this.DragButton2 = intl.getHTML('GetStartGuid.DragButton2');
    this.ChooseFile = intl.formatMessage({ id: 'GetStartGuid.ChooseFile' });
    this.DragDes=intl.formatMessage({ id: 'GetStartGuid.DragDes' });
    this.blankDes=intl.formatMessage({ id: 'GetStartGuid.blankDes' });
  };
  doOpenFile = () => {
    this.props.openFile();
  };
  doOpenFileForDragDrop = ({ file }) => {
    if (file) {
      this.props.onDrop([file]);
    }
  };
  onShowSignUpDlg = (ev) => {
    const { hasSignIn } = store.userStore
    const node = ev.target;
    //  .choose-file-btn
    if (!node || !node.className) {
      return;
    }
    let className = node.className;
    let pos = className.indexOf('choose-file-btn');
    if (pos === -1) {
      return;
    }

    if (!hasSignIn) {
      store.appStore.doShowSignInDialog();
    } else {
      this.props.onDrop([]);
    }
  };
  menuList=()=>{
    return (
      <Menu>
        <Menu.Item key="1">
          <div className="select-wrapper" onClick={() => this.props.showOpenFileDlg('OneDrive')}>
            <i className="select-icon drive-icon" />
            OneDrive
          </div>
        </Menu.Item>
        <Menu.Item key="2">
          <div className="select-wrapper" onClick={() => this.props.showOpenFileDlg('Box')}>
            <i className="select-icon box-icon" />
            Box
          </div>
        </Menu.Item>
        <Menu.Item key="3">
          <div className="select-wrapper" onClick={() => this.props.showOpenFileDlg('Dropbox')}>
            <i className="select-icon drop-icon" />
            Dropbox
          </div>
        </Menu.Item>
        <Menu.Item key="4">
          <div className="select-wrapper" onClick={() => this.props.showOpenFileDlg('GoogleDrive')}>
            <i className="select-icon google-icon" />
            Google Drive
          </div>
        </Menu.Item>
        <Menu.Item key="5">
          <div className="select-wrapper" onClick={() => this.props.showOpenFileDlg(`${iManage}`)}>
            <i className="select-icon imanage-icon" />
            {intl.get('IManage.title')}
          </div>
        </Menu.Item>
        {store.netDriverStore.drivers.map((item, index)=>{
          let driverId = item.driverId;
          let icon = item.icon.normal;
          return (
              <Menu.Item key={index}>
                <div className="select-wrapper" onClick={() => this.props.showOpenFileDlg(driverId)}>
                  <i className="select-icon google-icon"
                  style={{ backgroundImage: `url(${icon})`,width: '24px',marginLeft:'-4px', marginTop:'-4px',height:'24px'}}>
                  </i>
                  {item.title}
                </div>
              </Menu.Item>
          )
        })
        }
      </Menu>
    )
  }
  render() {
    let result;
    const { onlyButton, disabledOpenFile } = this.props;
    const chooseProps = {
        accept: this.props.supportDocumentSuffixs,
        showUploadList: false,
        multiple:false,
        customRequest: ({file}) => {
          if (file) {
            this.props.onDrop([file]);
          }
        }
    }
    this.initIntlLang();

    result = (
      <React.Fragment>
        <div className={onlyButton?"":"open-file-wrapper"}>
          {
            !onlyButton &&
            <div className="position-wrapper">
                {
                  isCNDomain() ?
                    <Upload {...chooseProps} className="ant-btn choose-file-btn online-solid-btn" disabled={disabledOpenFile}>
                      {intl.get('ConvertPopup.chooseFile')}
                    </Upload>
                    :
                    <div className="drop-wrap">
                      {
                        disabledOpenFile?
                        <div className="choose-file-btn upload-btn" onClick={this.onShowSignUpDlg}>{intl.get('ConvertPopup.chooseFile')}</div>
                        :
                        <Upload {...chooseProps}>
                          <div className="upload-btn">{intl.get('ConvertPopup.chooseFile')}</div>
                        </Upload>
                      }
                      
                      <Dropdown overlay={this.menuList()} disabled={disabledOpenFile} placement="bottomRight" trigger={['click']} overlayStyle={{ width: "134px" }}>
                        <div className="arrow-wrap">
                          <i className="arrow-btn" />
                        </div>
                      </Dropdown>
                    </div>
                }
              <Button type="link" className="blank-btn" onClick={this.props.openBlankFile}>{this.blankDes}</Button>
            </div>
          }
          <Dragger
            disabled={disabledOpenFile}
            className={onlyButton?"":"drop-zone-wrapper"}
            accept={this.props.supportDocumentSuffixs}
            customRequest={this.doOpenFileForDragDrop}
            multiple={false}
            showUploadList={false}>
            {!onlyButton && <i className="icon" />}
            <div className="content-wrapper">
              {!onlyButton && <div className="title">{this.StartPDFHere}</div>}
              {!onlyButton && <div className="describe">{this.StartPDFHereDescribe}</div>}
              {!onlyButton &&<div className="DragDes">{this.DragDes}</div>}
              {!disabledOpenFile && onlyButton && <div className="btn-wrapper">{this.DragButton2}</div>}
            </div>
          </Dragger>
        </div>
      </React.Fragment>
    );

    return result;
  }
}

export default OpenFile;
